import { Input } from '@iwoca/orion';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { numbersOnly } from '../../../../forms/helpers/normalisers';
import type { CompanyDetailsFormValues } from '../CompanyDetails.types';
import { FieldRow } from '../FieldRow';

export const AnnualProfitQuestion = () => {
    const {
        control,
        formState: { errors }
    } = useFormContext<CompanyDetailsFormValues>();

    return (
        <FieldRow
            htmlFor="annualProfit"
            label={
                <FormattedMessage
                    id="_.your_company.annual_profit"
                    defaultMessage="Last 12 months profit (before tax)"
                />
            }
        >
            <Controller
                control={control}
                name="annualProfit"
                render={({ field: { onChange, value, onBlur, name, ref } }) => (
                    /* eslint-disable-next-line iwoca/input-a11y */
                    <Input
                        ref={ref}
                        id="annualProfit"
                        name={name}
                        className="fs-exclude"
                        value={value ?? ''}
                        onBlur={onBlur}
                        onChange={(e) => onChange(numbersOnly(e.target.value))}
                        error={errors.annualProfit?.message}
                    />
                )}
            />
        </FieldRow>
    );
};
